import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Alert, Divider, Input, Table } from "antd";
import { StandardTabs, Tab } from "@ts-digital/vrc";
import { canSeeColumnsFiltered } from "../../libs/utils";
import { canUploadColumns } from "../../constants/canUploadColumns";
import { canDoColumns } from "../../constants/canDoColumns";
import {
  businessPerformanceClientsColumns,
  businessPerformanceProvidersColumns,
  businessPerformancePortfolioColumns,
  businessPerformanceStoreColumns,
} from "../../constants/businessPerformanceColumns";
import "./style.css";
import { FormattedMessage, useIntl } from "react-intl";
import { GetSelectedCompanyStudio } from "../../libs/companiesUtils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { loadCompanyForSettings } from "../../store/actions/permissions";

const Search = Input.Search;

const SettingsSummaryTable = (props) => {
  const dispatch = useDispatch();
  const currentPermissions = useSelector((state) => state.currentPermissions);
  const main = useSelector((state) => state.main);
  const user = useSelector((state) => state.user);
  const [activeTab, setActiveTab] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  //const [cancelSearch, setCancelSearch] = useState(false); // Set if show "search" icon or "x" icon in the top input field

  const [lastSearchValue, setLastSearchValue] = useState("");

  useEffect(() => {
    if (searchValue === "" && lastSearchValue !== "") {
      dispatch(loadCompanyForSettings("", 0, 100, [], main?.accountantIdSelected));
    }
    setLastSearchValue(searchValue);
  }, [searchValue, lastSearchValue, dispatch, main?.accountantIdSelected]);

  const studioFind = GetSelectedCompanyStudio();

  const intl = useIntl();

  const handleTabChange = (e) => {
    setActiveTab(e);
  };

  if (currentPermissions.permissionClientsList === null) {
    return null;
  }
  const companies = currentPermissions.companySettingsList.companies;
  const listClientsSettings = currentPermissions.permissionClientsList.listClientsSettings;
  const rawPermissions = listClientsSettings.map((client) => client.map((cl) => cl.permissions)).flat();
  const specificPermissions = rawPermissions.map((perm) => perm.map((p) => p.permissions));
  const specificPermissionsFlat = specificPermissions.map((sp) => sp.flat());

  const permissionsInDataRaw = specificPermissionsFlat.map((spf) => {
    return spf.reduce((obj, item) => Object.assign(obj, { [item.functionSmallLabel]: item.isActive }), {});
  });

  let permissionsInData = listClientsSettings.flatMap((list, index) => {
    const companyObject = companies.find((obj) => {
      return obj.uuid === list[0].companyId;
    });

    if (companyObject === undefined) {
      return null;
    }

    return {
      ...list,
      ...permissionsInDataRaw[index],
      companyName: companyObject !== undefined ? companyObject.ragioneSociale : "null",
    };
  });

  permissionsInData = permissionsInData.filter((item) => item !== null);

  let classNameTab = "tabSummaryTable";
  if (user?.profile?.language === "es-ES") {
    classNameTab = "tabSummaryTable spanish";
  }

  return (
    <>
      {(companies?.length > 98 || searchValue) && (
        <>
          <Alert
            style={{ wordBreak: "break-word" }}
            message={intl?.formatMessage({ id: "settings.tooManyCompanies" })}
            description={intl?.formatMessage({ id: "settings.tooManyCompaniesDescription" })}
            type="warning"
            showIcon
          />
          <br />
          <div style={{ maxWidth: 520 }}>
            <Search
              autoFocus
              value={searchValue}
              placeholder={intl?.formatMessage({ id: "settings.searchCompanyPlaceholder" })}
              size="large"
              enterButton={<FontAwesomeIcon icon={["fal", "search"]} />}
              onSearch={(val, e) => {
                if (e?.target?.dataset?.icon === "times") {
                  setSearchValue("");
                  dispatch(loadCompanyForSettings("", 0, 100, [], main?.accountantIdSelected));
                  return;
                } else {
                  if (val?.trim().length > 2) {
                    dispatch(loadCompanyForSettings(val, 0, 100, [], main?.accountantIdSelected));
                  }
                }
              }}
              onChange={(e) => {
                setSearchValue(e.target.value);
              }}
            />
            <Divider />
          </div>
        </>
      )}
      <StandardTabs className="standardTabsSummaryTable" activeIndex={activeTab} onChange={handleTabChange}>
        <Tab style={{ width: "500px" }} key={0} className={classNameTab}>
          <FormattedMessage id="settings.summaryTable.canSeeTitle" />
        </Tab>
        <Tab style={{ width: "500px" }} key={1} className={classNameTab}>
          <FormattedMessage id="settings.summaryTable.canUploadTitle" />
        </Tab>
        {studioFind?.taxRegion !== "ES" ? (
          <Tab style={{ width: "500px" }} key={2} className={classNameTab}>
            <FormattedMessage id="settings.summaryTable.canDoTitle" />
          </Tab>
        ) : (
          <></>
        )}
        <Tab style={{ width: "500px" }} key={3} className={classNameTab}>
          <FormattedMessage id="settings.summaryTable.bpClientsTitle" />
        </Tab>
        <Tab style={{ width: "500px" }} key={4} className={classNameTab}>
          <FormattedMessage id="settings.summaryTable.bpProvidersTitle" />
        </Tab>
        <Tab style={{ width: "500px" }} key={5} className={classNameTab}>
          <FormattedMessage id="settings.summaryTable.bpPortfolioTitle" />
        </Tab>
        <Tab style={{ width: "500px" }} key={76} className={classNameTab}>
          <FormattedMessage id="settings.summaryTable.bpStoreTitle" />
        </Tab>
      </StandardTabs>
      <Table
        dataSource={permissionsInData}
        columns={
          activeTab === 0
            ? canSeeColumnsFiltered(user?.profile?.language === "es-ES" ? intl : null, user?.profile?.language === "es-ES")
            : activeTab === 1
            ? canUploadColumns(user?.profile?.language === "es-ES" ? intl : null, user?.profile?.language === "es-ES")
            : activeTab === 2
            ? canDoColumns(user?.profile?.language === "es-ES" ? intl : null, user?.profile?.language === "es-ES")
            : activeTab === 3
            ? businessPerformanceClientsColumns(user?.profile?.language === "es-ES" ? intl : null, user?.profile?.language === "es-ES")
            : activeTab === 4
            ? businessPerformanceProvidersColumns(user?.profile?.language === "es-ES" ? intl : null, user?.profile?.language === "es-ES")
            : activeTab === 5
            ? businessPerformancePortfolioColumns(user?.profile?.language === "es-ES" ? intl : null, user?.profile?.language === "es-ES")
            : businessPerformanceStoreColumns(user?.profile?.language === "es-ES" ? intl : null, user?.profile?.language === "es-ES")
        }
      />
    </>
  );
};

export default SettingsSummaryTable;
